import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { DiscountRequest } from './discount-request';

@Component({
  selector: 'cs-discount-request',
  standalone: false,
  templateUrl: './discount-request.component.html',
  styleUrls: ['./discount-request.component.scss']
})
export class DiscountRequestComponent implements OnInit, OnDestroy {
  public discountRequests: Array<DiscountRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getDiscountRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.discountRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: DiscountRequest): void {
    this.router.navigate(['/crm/customers/discount-requests/approval'], {
      queryParams: { discountId: request.discountRequestId }
    });
    this.closeTodo.emit();
  }
}
